/**
 * @generated SignedSource<<9d72aba52deac75607410fe37ca1b0be>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templatePaginatedSearchResultsContentfulRelayRefetchableFragment$data = {
  readonly templates: {
    readonly items: ReadonlyArray<{
      readonly productCollection: {
        readonly items: ReadonlyArray<{
          readonly productNameReference: {
            readonly productNameId: string | null | undefined;
          } | null | undefined;
        } | null | undefined>;
      } | null | undefined;
      readonly sys: {
        readonly id: string;
      };
      readonly templateNameExternal: string | null | undefined;
      readonly urlSlug: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"templateCardContentfulRelayFragment">;
    } | null | undefined>;
    readonly total: number;
  } | null | undefined;
  readonly " $fragmentType": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment";
};
export type templatePaginatedSearchResultsContentfulRelayRefetchableFragment$key = {
  readonly " $data"?: templatePaginatedSearchResultsContentfulRelayRefetchableFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templatePaginatedSearchResultsContentfulRelayRefetchableFragment">;
};

import templatePaginatedSearchResultsRefetchableQuery_graphql from './templatePaginatedSearchResultsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "categoryUrlSlugs"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "limit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "locale"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "skip"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "templateIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "urlSlugs"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": templatePaginatedSearchResultsRefetchableQuery_graphql
    }
  },
  "name": "templatePaginatedSearchResultsContentfulRelayRefetchableFragment",
  "selections": [
    {
      "alias": "templates",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "limit"
        },
        {
          "kind": "Variable",
          "name": "locale",
          "variableName": "locale"
        },
        {
          "kind": "Variable",
          "name": "skip",
          "variableName": "skip"
        },
        {
          "fields": [
            {
              "items": [
                {
                  "fields": [
                    {
                      "kind": "Variable",
                      "name": "urlSlug_in",
                      "variableName": "urlSlugs"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "OR.0"
                },
                {
                  "fields": [
                    {
                      "fields": [
                        {
                          "kind": "Variable",
                          "name": "id_in",
                          "variableName": "templateIds"
                        }
                      ],
                      "kind": "ObjectValue",
                      "name": "sys"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "OR.1"
                },
                {
                  "fields": [
                    {
                      "fields": [
                        {
                          "kind": "Variable",
                          "name": "urlSlug_in",
                          "variableName": "categoryUrlSlugs"
                        }
                      ],
                      "kind": "ObjectValue",
                      "name": "category"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "OR.2"
                }
              ],
              "kind": "ListValue",
              "name": "OR"
            }
          ],
          "kind": "ObjectValue",
          "name": "where"
        }
      ],
      "concreteType": "ProductTemplateCollection",
      "kind": "LinkedField",
      "name": "productTemplateCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductTemplate",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Sys",
              "kind": "LinkedField",
              "name": "sys",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "limit",
                  "value": 1
                }
              ],
              "concreteType": "ProductTemplateProductCollection",
              "kind": "LinkedField",
              "name": "productCollection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductListing",
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductName",
                      "kind": "LinkedField",
                      "name": "productNameReference",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "productNameId",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "productCollection(limit:1)"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateNameExternal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlSlug",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "templateCardContentfulRelayFragment"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "total",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "251a112050a3678aba1b8b73da60c6b5";

export default node;
